<template>
  <div id="knowledge-base-page">

    <!-- KNOWLEDGE BASE CARDS  -->
    <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 lg:w-1/4 mb-base" v-for="(item,index) in card_data" :key="index">
        <router-link :to="myLink(item)">
          <vx-card>
            <div slot="no-body">
              <img :src="item.image" alt="content-img"
                   class="responsive card-img-top" style="height: 240px;">
            </div>

            <h5 class="mb-4" style="height: 38px;overflow: hidden;">{{ trunc(item.title, 60) }}</h5>
              <p class="text-dark mt-2 text-sm">
                  {{ $t('startAt') }} : {{ item.start_at }}
                  <br>
                  {{ $t('endAt') }} : {{ item.end_at }}
              </p>
            <div class="flex justify-between flex-wrap">
              <vs-button class="mt-4 ml-auto" type="border" color="#b9b9b9">{{ $t('view') }}</vs-button>
            </div>
          </vx-card>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        card_data: [],
      }
    },
      methods: {
          myLink(item) {
              return `/pages/events/${item.id}`
          },
          trunc(text, n){
              return text.substr(0,n-1)+(text.length>n?'...':'');
          },
      },
    created() {
      const thisIns = this;

      // eslint-disable-next-line no-undef
      axios.get(apiUrl+'/event?token='+token)
          .then(function (response) {

              let data = response.data;
              if(data.code === 200){
                  thisIns.card_data = data.data;
              }else{
                  if (data.code === 401){
                      window.logout();
                  }
                  thisIns.$vs.notify({
                      title: 'Error',
                      text:  data.message,
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle'
                  });
              }

          });
    },
    components: {}
  }
</script>

<style lang="scss">
  .text-grey_ {
    color: #636363 !important
  }

  .knowledge-base-jumbotron-content {
    background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
    background-size: cover;
  }
</style>
